import { useLazyGetQuestionFeedbackQuery } from '../slices/fun_stuff/quizAdminSlice';
import { useDispatch } from 'react-redux';
import { setQuestionFeedback } from '../slices/fun_stuff/quizAuthSlice';

export const useLoadQuestionFeedback = () => {
  const dispatch = useDispatch();
  const [getFeedback, { isLoading, error }] = useLazyGetQuestionFeedbackQuery();

  const loadQuestionFeedback = async () => {
    const data = await getFeedback().unwrap();
    dispatch(setQuestionFeedback(data));
    return;
  };

  return { loadQuestionFeedback, isLoading, error };
};
